import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import ContactBackgrounddamask from '../assets/images/White_damask.webp';
import Facebook from '../assets/images/facebook.png';
import Instagram from '../assets/images/Insta_Icon.png';
import Tiktok from '../assets/images/tiktok-icon.png';
import WorkSchedule from './WorkSchedule';

const ContactSection = () => {
  const [isScheduleExpanded, setIsScheduleExpanded] = useState(false);
  
  // Reusable font styles to eliminate repetition
  const fontStyles = {
    actionButton: {
      width: '150px',
      height: '25px',
      fontFamily: 'Montserrat',
      fontWeight: 700,
      fontStyle: 'Bold',
      fontSize: '16px',
      lineHeight: '156%',
      letterSpacing: '0.32em',
      textAlign: 'center',
      textTransform: 'uppercase',
      textDecoration: 'underline',
      textDecorationStyle: 'solid',
      textDecorationOffset: '0%',
      textDecorationThickness: '0%',
      color: '#C7A064'
    },
    mainHeading: {
      fontFamily: 'Montserrat',
      fontWeight: 700,
      fontStyle: 'Bold',
      fontSize: '40px',
      lineHeight: '100%',
      letterSpacing: '0.04em',
      textAlign: 'center',
      textTransform: 'uppercase',
      color: '#000000'
    },
    subtitle: {
      fontFamily: 'Montserrat',
      fontWeight: 400,
      fontStyle: 'Regular',
      fontSize: '16px',
      lineHeight: '100%',
      letterSpacing: '0.2em',
      textAlign: 'center',
      textTransform: 'uppercase',
      color: '#000000'
    },
    quentin: {
      fontFamily: 'Quentin',
      fontWeight: 400,
      fontStyle: 'normal',
      fontSize: '160px',
      lineHeight: '100%',
      letterSpacing: '0%',
      textAlign: 'center'
    },
    convenientText: {
      fontFamily: 'Montserrat',
      fontWeight: 600,
      fontStyle: 'SemiBold',
      fontSize: '16px',
      lineHeight: '156%',
      letterSpacing: '0.2em',
      textAlign: 'center',
      textTransform: 'uppercase'
    },
    subtext: {
      fontFamily: 'Montserrat',
      fontWeight: 400,
      fontStyle: 'Regular',
      fontSize: '16px',
      lineHeight: '156%',
      letterSpacing: '0em',
      textAlign: 'center'
    },
    addressText: {
      fontFamily: 'Montserrat',
      fontWeight: 400,
      fontStyle: 'Regular',
      fontSize: '20px',
      lineHeight: '176%',
      letterSpacing: '0em',
      textAlign: 'center'
    }
  };

  useEffect(() => {
    // Initialize Leaflet map
    const initializeMap = () => {
      // Check if map already exists and remove it
      const existingMap = window.mapInstance;
      if (existingMap) {
        existingMap.remove();
      }

      // Initialize map at Hair To Dye For location in Easton, PA
      // 200 Northampton St, Easton, PA 18042
      const map = window.L.map('interactive-map').setView([40.6893, -75.2090], 15);
      window.mapInstance = map;

      // Light/Minimal map style to match the design
      const lightMap = window.L.tileLayer(
        'https://cartodb-basemaps-a.global.ssl.fastly.net/light_all/{z}/{x}/{y}{r}.png', {
          attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OSM</a> &copy; <a href="https://carto.com/">CARTO</a>',
          subdomains: 'abcd',
          maxZoom: 19
      });

      // Add the light map layer
      lightMap.addTo(map);

      // Custom marker icon
      const customIcon = window.L.icon({
        iconUrl: "https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-black.png",
        shadowUrl: "https://unpkg.com/leaflet/dist/images/marker-shadow.png",
        iconSize: [25, 41],
        iconAnchor: [12, 41],
        popupAnchor: [1, -34],
        shadowSize: [41, 41]
      });

      // Add marker for Hair To Dye For
      window.L.marker([40.6893, -75.2090], { icon: customIcon }).addTo(map)
        .bindPopup(`
          <div style="text-align: center; font-family: 'Montserrat', sans-serif;">
            <strong>Hair To Dye For</strong><br/>
            200 Northampton St<br/>
            Easton, PA 18042<br/>
            <a href="tel:16109233530">(610) 923-3530</a>
          </div>
        `)
        .openPopup();

      // Disable scroll zoom to prevent accidental zooming
      map.scrollWheelZoom.disable();
      
      // Enable scroll zoom when map is clicked
      map.on('click', function() {
        map.scrollWheelZoom.enable();
      });
      
      // Disable scroll zoom when mouse leaves the map
      map.on('mouseout', function() {
        map.scrollWheelZoom.disable();
      });
    };

    // Load Leaflet CSS and JS if not already loaded
    if (!window.L) {
      // Load Leaflet CSS
      const leafletCSS = document.createElement('link');
      leafletCSS.rel = 'stylesheet';
      leafletCSS.href = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.css';
      document.head.appendChild(leafletCSS);

      // Load Leaflet JS
      const leafletJS = document.createElement('script');
      leafletJS.src = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.js';
      leafletJS.onload = () => {
        setTimeout(initializeMap, 100); // Small delay to ensure CSS is loaded
      };
      document.head.appendChild(leafletJS);
    } else {
      // Leaflet already loaded, initialize map
      setTimeout(initializeMap, 100);
    }

    // Cleanup function
    return () => {
      if (window.mapInstance) {
        window.mapInstance.remove();
        window.mapInstance = null;
      }
    };
  }, []);

  return (
    <section className="flex flex-col lg:flex-row relative w-full min-h-screen">
      {/* Left Content Section */}
      <div 
        className="w-full lg:w-1/2 flex flex-col p-6 sm:p-8 lg:p-16 relative z-10 min-h-[600px] lg:min-h-screen"
        style={{
          backgroundImage: `url(${ContactBackgrounddamask})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat'
        }}
      >
        <div className="w-full flex flex-col items-center flex-grow">
          {/* Top Section */}
          <div className="w-full flex flex-col items-center mb-8 lg:mb-12">
            {/* Welcome Text - Responsive */}
            <h2 className="text-6xl sm:text-7xl md:text-8xl lg:text-9xl mb-4" 
              style={{
                fontFamily: 'Quentin',
                fontWeight: 400,
                fontStyle: 'normal',
                lineHeight: '100%',
                textAlign: 'center',
                color: '#F2EADC'
              }}>
              Welcome
            </h2>
            
            {/* Since 2005 - Responsive */}
            <p className="text-sm sm:text-base mb-4"
              style={{
                fontFamily: 'Montserrat',
                fontWeight: 400,
                fontSize: '16px',
                lineHeight: '100%',
                letterSpacing: '0.2em',
                textAlign: 'center',
                textTransform: 'uppercase',
                color: '#000000'
              }}
            >
              SINCE 2005
            </p>
            
            {/* Main Heading - Responsive */}
            <h3 className="text-xl sm:text-2xl md:text-3xl lg:text-[40px] px-4 max-w-[90%]"
              style={{
                fontFamily: 'Montserrat',
                fontWeight: 700,
                lineHeight: '110%',
                letterSpacing: '0.04em',
                textAlign: 'center',
                textTransform: 'uppercase',
                color: '#000000'
              }}
            >
              VISIT HAIR TO DYE FOR IN EASTON
            </h3>
          </div>
          
          {/* Scrollable Content Container */}
          <div className="w-full max-w-[500px] px-4 overflow-y-auto flex-grow">
            {/* Convenient Location Text */}
            <p className="mb-6 text-center text-sm sm:text-base"
              style={{ 
                fontFamily: 'Montserrat',
                fontWeight: 600,
                fontSize: '16px',
                lineHeight: '156%',
                letterSpacing: '0.2em',
                textTransform: 'uppercase',
                color: '#000000'
              }}
            >
              CONVENIENT LOCATION, FLEXIBLE HOURS
            </p>
            
            {/* Description Text */}
            <p className="text-sm sm:text-base mb-8 text-center px-2"
              style={{ 
                fontFamily: 'Montserrat',
                fontWeight: 400,
                lineHeight: '156%',
                color: '#000000'
              }}
            > 
            Find us in downtown Easton with easy booking options by phone. 
            Check our hours and location below or get directions on Google Maps.
            </p>
            
            {/* Work Schedule Component */}
            {/* <WorkSchedule onExpandChange={setIsScheduleExpanded} /> */}
            <a
  href="/contact"
  style={{
    color: "#C7A064",
    textAlign: "center",
    fontFamily: "Montserrat, sans-serif",
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: 700,
    lineHeight: "156%", // 24.96px
    letterSpacing: "3.2px",
    textDecorationLine: "underline",
    textDecorationStyle: "solid",
    textDecorationSkipInk: "none",
    textDecorationThickness: "auto",
    textUnderlineOffset: "auto",
    textTransform: "uppercase",
    display: "block",
    marginTop: "20px",
    marginBottom: "20px", 
  }}
>
  View Working hours
</a>

            {/* Contact Info */}
            <div className="text-center mb-8">
              <p className="mb-4 text-lg sm:text-xl font-bold"
                style={{ 
                  fontFamily: 'Montserrat',
                  color: '#000000'
                }}
              >
                <a href="tel:+16109233530" className="hover:opacity-80 transition-opacity">
                  1 (610) 923-3530
                </a>
              </p>
              
              <div className="w-48 sm:w-64 h-px mx-auto mb-4" style={{ backgroundColor: '#F2EADC' }}></div>
              
              <p className="text-base sm:text-lg"
                style={{ 
                  fontFamily: 'Montserrat',
                  fontWeight: 400,
                  lineHeight: '176%',
                  color: '#1D1D1D'
                }}
              >
                200 Northampton St, Easton, PA 18042
              </p>
            </div>
            
            {/* Social Media & CTA */}
            <div className="text-center pb-8">
              <div className="flex justify-center space-x-6 mb-6">
                <button 
                  onClick={() => window.open('https://www.facebook.com/h2d4easton', '_blank', 'noopener,noreferrer')}
                  className="w-10 h-10 sm:w-12 sm:h-12 bg-[#F2EADC] rounded-full flex items-center justify-center hover:bg-[#E8DCC4] transition-colors shadow-lg"
                  aria-label="Visit our Facebook page"
                >
                  <img src={Facebook} alt="Facebook" className="w-10 h-10 sm:w-12 sm:h-12" />
                </button>
                <button 
                  onClick={() => window.open('https://www.instagram.com/h2d4easton/', '_blank', 'noopener,noreferrer')}
                  className="w-10 h-10 sm:w-12 sm:h-12 bg-[#F2EADC] rounded-full flex items-center justify-center hover:bg-[#E8DCC4] transition-colors shadow-lg"
                  aria-label="Visit our Instagram page"
                >
                  <img src={Instagram} alt="Instagram" className="w-10 h-10 sm:w-12 sm:h-12" />
                </button>
                <button 
                  onClick={() => window.open('https://www.tiktok.com/@h2d4easton', '_blank', 'noopener,noreferrer')}
                  className="w-10 h-10 sm:w-12 sm:h-12 bg-[#F2EADC] rounded-full flex items-center justify-center hover:bg-[#E8DCC4] transition-colors shadow-lg"
                  aria-label="Visit our Tiktok page"
                >
                  <img src={Tiktok} alt="Tiktok" className="w-10 h-10 sm:w-12 sm:h-12" />
                </button>
              </div>
              
              <a
                href="tel:+16109233530"
                className="inline-block px-6 py-2 text-sm sm:text-base"
                style={{ 
                  fontFamily: 'Montserrat',
                  fontWeight: 700,
                  fontSize: '16px',
                  lineHeight: '156%',
                  letterSpacing: '0.32em',
                  textTransform: 'uppercase',
                  textDecoration: 'underline',
                  color: '#C7A064'
                }}
              >
                CALL TO BOOK NOW
              </a>
            </div>
          </div>
        </div>
      </div>
      
      {/* Map Section - Responsive */}
      <div className="w-full lg:w-1/2 bg-gray-100 flex items-center justify-center relative h-[400px] sm:h-[500px] lg:h-screen">
        {/* Interactive Map Container */}
        <div 
          id="interactive-map" 
          className="w-full h-full"
          style={{ 
            width: '100%', 
            height: '100%',
            position: 'relative',
            zIndex: 1
          }}
        />
        
        {/* Custom styles for the map */}
        <style>{`
          #interactive-map {
            filter: brightness(1.05) contrast(0.95);
          }
          
          #interactive-map .leaflet-control-attribution {
            font-size: 10px;
            background: rgba(255, 255, 255, 0.7);
          }
          
          #interactive-map .leaflet-popup-content-wrapper {
            border-radius: 8px;
            box-shadow: 0 3px 10px rgba(0,0,0,0.2);
          }
          
          #interactive-map .leaflet-popup-content {
            margin: 13px 19px;
            line-height: 1.4;
          }
          
          /* Style the map controls */
          #interactive-map .leaflet-control-zoom {
            border: none;
            box-shadow: 0 1px 5px rgba(0,0,0,0.4);
          }
          
          #interactive-map .leaflet-control-zoom a {
            background-color: white;
            color: #333;
            font-size: 18px;
            font-weight: bold;
          }
          
          #interactive-map .leaflet-control-zoom a:hover {
            background-color: #f4f4f4;
          }
          
          /* Mobile specific styles */
          @media (max-width: 640px) {
            #interactive-map .leaflet-control-zoom {
              transform: scale(0.9);
            }
          }
        `}</style>
      </div>
    </section>
  );
};

export default ContactSection;